import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  useNavigate, useParams
} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Box,
  Toolbar, Container,
  Typography,
  InputAdornment,
} from '@mui/material';
import { getExistEmailAction, getInvitationFormAction, listTenantsAction } from '@ivymobi/orbit-core/business/tenant';
import { sendLoginMobileCodeAction } from '@ivymobi/orbit-core/business/user';
import { User } from '@ivymobi/orbit-core';
import { useTranslation } from 'react-i18next';
import { isEmpty, get } from 'lodash';
import LCountrySelect from '@ivymobi/orbit-core/components/CountrySelect/countrySelect';

import {
  Form, FormDataConsumer,
  TextInput, SaveButton,
  required,
  isEmail,
  isPhone
} from '../components';
import Loader from '../components/loaders';
import { SendSmsCodeButton } from './smsCode';
import { useForm } from 'react-hook-form';
import LanguageMenu from '../layout/languageMenu';
import { getJSON, postJSON } from '../api';
import { showNotification } from '@ivymobi/orbit-core/business/notification';
import { isMemberCompanyModuleEnabled } from './invitationCompanyField';

const  IsPC = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod'];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};

interface InvitationFormProps {
  id: string;
  user: { token: string; user: User };
  inviter: { id: string };
  acceptInvitation: (data) => Promise<void>;
  doSendCode: (phone: string, countryCode: string) => Promise<void>;
  doSendEmailCode: (email: string) => Promise<void>;
  myEmail?: string;
  showCompanyName?: boolean;
}
function InvitaionForm(props: InvitationFormProps) {
  const [t, i18n] = useTranslation();

  const { user, id, acceptInvitation, doSendCode, doSendEmailCode, myEmail, showCompanyName } = props;
  const { register, getValues, setValue } = useForm<{
    mobile: string;
    code: string;
    countryCode: string;
    email: string;
  }>({ mode: 'onChange', defaultValues: { mobile: '', code: '', countryCode: '+86', email:myEmail} });

  const phone = user.user?.phone;
  const [flush, setFlush] = useState(true);

  const defaultValue = { invitationId: id, phone, email:myEmail};

  const FormToolBar = () => {
    return (
      <Toolbar style={{ paddingLeft: '32px', paddingRight: '32px' }}>
        <SaveButton fullWidth startIcon={null} size="large"
          disabled={false} label={t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040208')}
        />
      </Toolbar>
    );
  };

  register({ name: 'countryCode' });

  const handleChange = (event) => {
    setValue('countryCode', '+' + event.target.value);
    setFlush(!flush);
  };


  return (
    <Form
      onSubmit={(data) => { 
        const result = {...data, phone:phone??data.phone, countryCode:getValues('countryCode'), email:((myEmail&&myEmail?.length>0)?myEmail:data.email)};
        acceptInvitation(result);
      }}
      defaultValues={defaultValue}
      toolbar={<FormToolBar />}
    >
      <TextInput name="name" label={t('YBT-ADMIN.YBT-ADMIN-030101.YBT-ADMIN-03010106')} fullWidth validate={[required()]}/>
      <Box  style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
        {!phone &&
           <LCountrySelect
             fullWidth={false}
             inputStyle={{marginLeft:'-12px', marginTop:'8px'}}
             SelectStyle={{padding:'4px 10px 10px 0px', width:'100px'}}
             name='countryCode'
             i18n={i18n}
             variant='standard'
             value={getValues('countryCode').replace('+', '')}
             label={t('login.country')}
             handleChange={handleChange}     />
        }
        <TextInput
          name="phone"
          label={t('YBT-ADMIN.YBT-ADMIN-030101.YBT-ADMIN-03010107')}
          style={{flexGrow:1}}
          validate={[required(), isPhone(t('Phone number format is incorrect')) ]}
          disabled={!!phone}
          InputProps={{
            startAdornment: <InputAdornment position="start">
              {getValues('countryCode')}
            </InputAdornment>,
          }}
        />
      </Box>
      {!phone && <FormDataConsumer>
        {({ formData }) => (
          <TextInput name="code" fullWidth
            label={t('SMS verification code')}
            validate={[required()]}
            autoComplete='new-password'
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SendSmsCodeButton
                    mobile={formData.phone}
                    countryCode={getValues('countryCode')}
                    doSendCode={(captchaToken) => doSendCode(formData.phone, getValues('countryCode'), captchaToken)}
                    disabled={!formData.phone}
                  />
                </InputAdornment>
              )
            }}
          />
        )}
      </FormDataConsumer>}
      <TextInput name="email" type='email' fullWidth 
        disabled={myEmail!=null && myEmail?.length>0}
        validate={[required(), isEmail(t('Email format is incorrect, please fill in again'))]}
        label={t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040205')}
      />
      { (myEmail==null || myEmail?.length==0) &&<FormDataConsumer>
        {({ formData }) => (
          <TextInput name="emailCode" label={t('email verification code')} fullWidth validate={[required()]}
            autoComplete='new-password'
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SendSmsCodeButton
                    doSendCode={() => doSendEmailCode(formData.email)}
                    disabled={!formData.email}
                  />
                </InputAdornment>
              )
            }}
          />
        )}
      </FormDataConsumer>}

      <TextInput name="department" label={t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040206')}
        fullWidth validate={[required()]}
      />
      <TextInput name="title" label={t('YBT-ADMIN.YBT-ADMIN-030103.YBT-ADMIN-03010319')} fullWidth validate={[required()]}/>
      {showCompanyName && (
        <TextInput
          name="companyName"
          label={t('YBT-ADMIN.YBT-ADMIN-030101.YBT-ADMIN-03010109')}
          fullWidth
          required
          validate={[required()]}
        />
      )}
    </Form>
  );
}

export default function Invitations(props) {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const local = i18n.language === 'zh-CN' ? 'zh' : i18n.language || 'zh';

  const { user, acceptInvitation } = props;
  const { invitationId } = useParams<{invitationId: string}>();
  const [invitation, setInvitation] = useState(null);
  const [myEmail, setMyEmail] = useState(null);
  const dispatch = useDispatch();
  const [showCompanyName, setShowCompanyName] = useState(false);

  // isMember 当前登录账号已经是该团队成员？ boolean
  const [isMember, setIsMember] = useState(false);

  // 根据 teams_module 配置决定是否展示公司字段（member_company）
  useEffect(() => {
    if (isEmpty(invitation) || invitation?.error) return;
    const tenantid = get(invitation, ['tenant', 'id'], '');
    if (!tenantid) { setShowCompanyName(false); return; }
    getJSON<{ tenantid: string; type: string; openornot: string }>({
      url: `tenants/${tenantid}/modules/member_company`,
    }).then((res) => {
      setShowCompanyName(isMemberCompanyModuleEnabled(res?.openornot));
    }).catch(() => {
      setShowCompanyName(false);
    });
  }, [invitation]);

  useEffect(() => {
    if (!isEmpty(user) && !isEmpty(invitation) ) {
      const tenantid = get(invitation, ['tenant', 'id'], '');
      (dispatch(
        listTenantsAction({user})
      ) as unknown as Promise<unknown>).then((res) => {
        const tenants = Array.isArray(res) ? (res as Array<{ id?: string }>) : [];
        const filterIndex = tenants.findIndex((item) => item?.id === tenantid);
        filterIndex === -1 ? setIsMember(false) : setIsMember(true);
      });
      //获取填写的邮箱
      (dispatch(getExistEmailAction({user, tenant:{id:tenantid}})) as unknown as Promise<unknown>).then((res) => {
        const data = (res ?? null) as ({ email?: string } | null);
        setMyEmail(data?.email ?? '');
        console.log('========', data?.email ?? '');
      }).catch(() => {
        setMyEmail('');
      });
    } else {
      setIsMember(false);
    }
  }, [dispatch, user, invitation]);

  useEffect(() => {
    (dispatch(getInvitationFormAction({ id: invitationId })) as unknown as Promise<unknown>)
    .then((res) => setInvitation(res), (error) => setInvitation({ error }));
  }, [dispatch, setInvitation]);

  const doSendCode = (mobile, countryCode, captchaToken: string) => {
    return (dispatch(sendLoginMobileCodeAction({ mobile, countryCode, captchaToken })) as unknown as Promise<unknown>)
    .then(
      () => dispatch(showNotification(t('Send Code Success'), 'success')),
      (err) => dispatch(showNotification(t(err.message), 'error')),
    );
  };

  const doSendEmailCode = async (email) => {
    try {
      const tenantid = get(invitation, ['tenant', 'id'], '');
      await postJSON({
        url: 'user/email/code',
        body: {
          email,
          lang: local,
          tenantId:tenantid
        }
      });
      dispatch(showNotification(t('Send Code Success'), 'success'));
    } catch (err) {
      dispatch(showNotification(t(err.message), 'error'));
    }
  };

  const handleAcceptInvitation = async (data) => {
    const res = await acceptInvitation(invitationId, data);
    if (!isEmpty(res)) {
      navigate('/choose', { replace: true });
      location.reload();
    }
  };
  if (!invitation ||(user?.user && myEmail==null)) {
    return <Loader />;
  }


  if (invitation.error) {
    return <p>{invitation.error.message}</p>;
  }
  return (
    <Box>
      <Box  style={{width:'98%', display:'flex', justifyContent:'flex-end'}}>
        <LanguageMenu />
      </Box>
      <Container maxWidth="sm" sx={{ py: 3 }} >
        <Typography variant='h6' align="center" gutterBottom>
          {invitation.inviter.name} {t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040201')}
        </Typography>
        <Box display="flex" alignItems="center" justifyContent="center" gap={2} mb={4}>
          <img style={{ objectFit: 'contain', minWidth: '32px', height: '32px' }}
            src={invitation.tenant.info.logo}
          />
          <Typography variant={IsPC()? 'h4' : 'h5'}>
            {invitation.tenant.name}
          </Typography>
        </Box>
        {!isMember && <Typography align="center" variant="subtitle2" color="textSecondary" >
          {t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040202')}
        </Typography>}
        {!isMember && <InvitaionForm id={invitationId} inviter={invitation.inviter}
          dispatch={dispatch}
          doSendCode={doSendCode}
          myEmail={myEmail}
          doSendEmailCode={doSendEmailCode}
          showCompanyName={showCompanyName}
          {...props}
          acceptInvitation={handleAcceptInvitation}
        />}
        {isMember && <Box>
          <Typography align="center" variant="h4" >
            {/* 您已加入该团队 */}
            {t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040216')}
          </Typography>
          <img style={{ objectFit: 'contain', display: 'block', margin: '20px auto', width: '80%', height: 'auto' }}
            src='/images/send_success.svg'
          />

        </Box>}
      </Container>
    </Box>

  );
}
